import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SubscriptionForm } from './SubscriptionForm.es.js';
import { DisclaimerText } from './DisclaimerText.es.js';

const ctaContainer = "_cta-container_17ytn_1";
const styles = {
	ctaContainer: ctaContainer
};

const SubscriptionFormWithDisclaimer = (_a) => {
  var { disclaimerTextColor = "primary", disclaimerTextType } = _a, restProps = __rest(_a, ["disclaimerTextColor", "disclaimerTextType"]);
  return jsxs("div", { className: styles.ctaContainer, "data-zds": true, children: [jsx(SubscriptionForm, Object.assign({}, restProps, { fluidInput: true })), jsx(DisclaimerText, { color: disclaimerTextColor, textType: disclaimerTextType })] });
};

export { SubscriptionFormWithDisclaimer };
//# sourceMappingURL=SubscriptionFormWithDisclaimer.es.js.map
